import React, { useState } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import './App.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
    } catch (error) {
      alert("Wrong email or password! Please try again.");
    }
  };

  const handleForgotPassword = async () => {
    if (!email) return alert("Please enter your email first.");
    try {
      await sendPasswordResetEmail(auth, email.trim());
      alert("Password reset link has been sent.");
    } catch (error) { alert("Something went wrong."); }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center', background: '#f0f2f5' }}>
      <div className="white-box" style={{ width: '400px', textAlign: 'center', padding: '40px', borderRadius: '25px' }}>
        <h2 style={{ marginBottom: '30px', color: '#4e43e7', fontWeight: '800' }}>KIZUNA SHOP LOGIN</h2>
        <form onSubmit={handleLogin}>
          <input className="input-field" type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} required />
          <div style={{ position: 'relative' }}>
            <input className="input-field" type={showPassword ? "text" : "password"} placeholder="Password" onChange={(e) => setPassword(e.target.value)} required />
            <span onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '15px', top: '15px', cursor: 'pointer' }}>{showPassword ? "🙈" : "👁️"}</span>
          </div>
          <button type="submit" className="stat-card red-g" style={{ width: '100%', border:'none', padding:'15px', cursor:'pointer', fontWeight:'bold' }}>Login</button>
        </form>
        <p onClick={handleForgotPassword} style={{ marginTop: '20px', color: '#4e43e7', cursor: 'pointer', fontSize: '13px' }}>Forgot Password?</p>
      </div>
    </div>
  );
};

export default Login;